var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
    'background-black': _vm.background == 0,
    'background-white': _vm.background == 1,
  }},[_c('div',{staticStyle:{"position":"relative"}},[_c('Header',{attrs:{"appBarChange":_vm.background}}),_c('v-main',[_c('transition',{attrs:{"name":"fade-transition"}},[_c('router-view',{on:{"update":_vm.changeBackground}})],1)],1),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }